export default "__VITE_ASSET__DIiTYq3n__"